module.exports = __webpack_public_path__ + "static/news1-5994c97036243058582f81348cbd47a0.png";